const indices = [
  { label: '动作冒险', icon: 'ri-sword-fill', desc: '高燃打斗·视觉盛宴', color: 'text-red-500', bg: 'bg-red-50' },
  { label: '喜剧搞笑', icon: 'ri-emotion-laugh-fill', desc: '欢乐不停·笑料百出', color: 'text-amber-500', bg: 'bg-amber-50' },
  { label: '爱情浪漫', icon: 'ri-heart-pulse-fill', desc: '甜蜜邂逅·心动时刻', color: 'text-pink-500', bg: 'bg-pink-50' },
  { label: '悬疑推理', icon: 'ri-search-eye-fill', desc: '烧脑剧情·层层反转', color: 'text-indigo-500', bg: 'bg-indigo-50' },
  { label: '科幻奇幻', icon: 'ri-rocket-2-fill', desc: '未来世界·无限想象', color: 'text-cyan-500', bg: 'bg-cyan-50' },
  { label: '纪录片', icon: 'ri-earth-fill', desc: '真实记录·探索世界', color: 'text-emerald-500', bg: 'bg-emerald-50' },
  { label: '综艺娱乐', icon: 'ri-mic-2-fill', desc: '热门综艺·轻松解压', color: 'text-orange-500', bg: 'bg-orange-50' },
  { label: '动漫番剧', icon: 'ri-ghost-smile-fill', desc: '二次元世界·热血追番', color: 'text-violet-500', bg: 'bg-violet-50' },
];

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2 text-center">
          专题合集
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">按类型快速探索你感兴趣的影视内容</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indices.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="group flex flex-col items-center gap-3 p-5 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:-translate-y-1 transition-all cursor-pointer"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.bg} ${item.color} group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{item.label}</span>
              <span className="text-xs text-foreground-400">{item.desc}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}